export default __webpack_public_path__ + "static/media/step_F_UA.15cdaeae.png";